// client/src/dnd/emitter_tool/hooks/useEmitterLayers.js
import { useState } from "react";

export default function useEmitterLayers({
  effectKey, selectedSprite, effectSettings, emitterShape, shapeSettings
}) {
  const [layers, setLayers] = useState([]);
  const [activeLayerIndex, setActiveLayerIndex] = useState(-1);

  const onAddChildFromParent = () => {
    setLayers((cur) => [
      ...cur,
      {
        id: Date.now(),
        name: `Layer ${cur.length + 1}`,
        enabled: true,
        effectKey,
        selectedSprite,
        effectSettings: { ...effectSettings },
        emitterShape,
        shapeSettings: { ...shapeSettings },
        infinite: false,
        infiniteRate: 30,
        aboveParent: true,
      },
    ]);
  };
  const onRemoveLayer = (idx) => {
    setLayers((arr) => arr.filter((_, i) => i !== idx));
    setActiveLayerIndex((i) => (i === idx ? -1 : i > idx ? i - 1 : i));
  };
  const onUpdateLayer = (idx, patch) => {
    setLayers((arr) =>
      arr.map((L, i) => (i === idx ? { ...L, ...(typeof patch === "function" ? patch(L) : patch) } : L))
    );
  };
  const onReorderLayers = (next) => Array.isArray(next) && setLayers(next);

  return {
    layers, setLayers, activeLayerIndex, setActiveLayerIndex,
    onAddChildFromParent, onRemoveLayer, onUpdateLayer, onReorderLayers,
  };
}
